module.exports = __webpack_public_path__ + "static/media/Sydney.78ac5465.png";